import axios from 'axios';
import _ from 'lodash';
import OnboardingUserTables from '@/enum/user/OnboardingUserTables';

const onboardingUserStore = {
  state: {
  },
  mutations: {
  },
  actions: {
    async getOnboardingUserById(context, userId) {
      return axios.get(
        `${window.BASE_API.ONBOARDING_USERS}/admin/user/${userId}`,
      ).then(response => _.get(response, 'data')).catch(error => Promise.reject(error));
    },
    async updateOnboardingUserData(context, data) {
      const { id, legalUser, ...dataToSave } = data;

      return axios.post(
        `${window.BASE_API.ONBOARDING_USERS}/admin/user/${id}`,
        serializeOnboardingUser(dataToSave, legalUser),
      );
    },
    async updateOnboardingUserCognito(context, data) {
      const { id, email } = data;

      return axios.put(
        `${window.BASE_API.ONBOARDING_USERS}/admin/user/${id}/change-email`,
        { email },
      );
    },
    async deleteOnboardingUserData(context, data) {
      const { id } = data;

      return axios.delete(
        `${window.BASE_API.ONBOARDING_USERS}/admin/user/${id}`,
      );
    },
    async lockOnboardingUserCognito(context, data) {
      const { id, value } = data;

      return axios.get(
        `${window.BASE_API.ONBOARDING_USERS}/admin/user/${id}/enabled/${value}`,
      );
    },
  },
};

const serializeOnboardingUser = (user, legalUser) => {
  const result = {
    formData: {
      naturalUser: user,
      legalUser,
    },
    limitedFields: 'basic',
    type: 'natural',
    table: OnboardingUserTables.USER_META_TABLE,
  };

  if (undefined !== legalUser) {
    result.formData.legalUser = legalUser;
  }

  return result;
};

export default onboardingUserStore;



// WEBPACK FOOTER //
// ./src/store/users/onboardingUserStore.js